import "./editorialForms.css";

const categories = [
  { id: "politics", name: "Política" },
  { id: "world", name: "Mundo" },
  { id: "business", name: "Negócios" },
  { id: "tech", name: "Tecnologia" },
  { id: "sports", name: "Esportes" },
  { id: "entertainment", name: "Entretenimento" },
  { id: "health", name: "Saúde" },
  { id: "science", name: "Ciência" },
  { id: "culture", name: "Cultura" },
];

export default function CNNForm({ data, onChange }) {
  return (
    <div className="editorial_form cnn_form">
      <div className="editorial_form_section">
        <label>
          Manchete <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Título principal da notícia"
          value={data?.headline || ""}
          onChange={(e) => onChange({ ...data, headline: e.target.value })}
          maxLength={200}
        />
        <span className="editorial_form_counter">
          {(data?.headline || "").length}/200
        </span>
      </div>

      <div className="editorial_form_section">
        <label>Subtítulo</label>
        <input
          type="text"
          placeholder="Linha de apoio (opcional)"
          value={data?.subheadline || ""}
          onChange={(e) => onChange({ ...data, subheadline: e.target.value })}
          maxLength={300}
        />
      </div>

      <div className="editorial_form_section">
        <label>Categoria</label>
        <select
          value={data?.category || ""}
          onChange={(e) => onChange({ ...data, category: e.target.value })}
        >
          <option value="">Selecione uma categoria</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.name}
            </option>
          ))}
        </select>
      </div>

      <div className="editorial_form_section">
        <label>Autor</label>
        <input
          type="text"
          placeholder="Nome do autor/repórter"
          value={data?.author || ""}
          onChange={(e) => onChange({ ...data, author: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkboxes">
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="isBreaking"
              checked={data?.isBreaking || false}
              onChange={(e) =>
                onChange({ ...data, isBreaking: e.target.checked })
              }
            />
            <label htmlFor="isBreaking" className="breaking_label">
              🔴 Breaking News
            </label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="isOpinion"
              checked={data?.isOpinion || false}
              onChange={(e) =>
                onChange({ ...data, isOpinion: e.target.checked })
              }
            />
            <label htmlFor="isOpinion">Artigo de Opinião</label>
          </div>
        </div>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
        </svg>
        <span>
          O conteúdo da notícia será escrito no campo de texto principal
        </span>
      </div>
    </div>
  );
}
